import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BaseButton, useIsMobile, Chip, useT } from '@repo/common';

const SUB_HEADERS = [
  'Applications',
  'Jobs',
  'My Workshops',
  'My Q&A',
  'My MVPs',
  'Login',
  'Social Login',
  'Account',
];
const MOBILE_INDENTED = ['My Workshops', 'My Q&A'];
const MOBILE_INDENTED_MVP = ['My MVPs'];

const LABELS_KR = {
  Applications: '지원 현황',
  Jobs: '채용 공고',
  'My Workshops': '내 워크숍',
  'My Q&A': '내 Q&A',
  'My MVPs': '내 MVP',
  Login: '로그인',
  'Social Login': '소셜 로그인',
  Account: '계정',
  Resumes: '이력서',
  'Your Journey Goal': '나의 여정 목표',
  'Workshop Bookings & Revenue': '워크숍 예약 및 수익',
  'Policy Notice': '약관 개정 안내',
  Policies: '정책 관리',
};

const HeaderText = ({
  label,
  showGoalTextArea = false,
  mvpsList,
  onSeeAll,
}) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const t = useT();

  const isSubHeader = SUB_HEADERS.includes(label);

  const getPaddingClass = () => {
    if (
      (label === 'Your Journey Goal' && !showGoalTextArea) ||
      (isMobile && showGoalTextArea)
    ) {
      return '';
    }

    if (isMobile) {
      if (MOBILE_INDENTED.includes(label)) return 'pl-2 pb-4';
      if (MOBILE_INDENTED_MVP.includes(label))
        return 'justify-between px-2 pb-4';
      if (
        label === 'Applications' ||
        label === 'Jobs' ||
        label === 'Login' ||
        label === 'Social Login' ||
        label === 'Account'
      )
        return 'pb-4';
      if (label === 'Resumes') return 'pb-2';
    }

    return 'pb-6';
  };

  const layoutClass = isSubHeader
    ? 'gap-4 typo-b18Strong tabletH:typo-title1'
    : 'gap-2 typo-title1';

  return (
    <div
      className={`flex items-center w-full ${getPaddingClass()} ${layoutClass} text-text-primary`}
    >
      {t(label, LABELS_KR[label] || label)}

      {label === 'Applications' && (
        <div
          className='typo-b12 tabletH:typo-b12Strong text-text-placeholder tabletH:text-purple-purple04 underline cursor-pointer'
          onClick={() => navigate('/jobs/hidden/all')}
        >
          {t('View hidden jobs', '숨긴 공고 보기')}
        </div>
      )}

      {label === 'My MVPs' && isMobile && mvpsList.length > 12 && (
        <div onClick={onSeeAll}>
          <Chip type='fill' hideIcon bgclass='py-1 px-2'>
            {t('See all', '전체 보기')}
          </Chip>
        </div>
      )}

      {label === 'Workshop Bookings & Revenue' && (
        <BaseButton hideIcon size='s' isDisabled>
          {t('Add Booking', '예약 추가')}
        </BaseButton>
      )}
    </div>
  );
};

export default HeaderText;
